import React from 'react';
import { useDispatch } from 'react-redux';

import CommonImage from '@components/CommonImage';
import LoaderComponent from '@components/LoaderComponent';

import useTrendResearchFilterParams from '@features/trend-research/hooks/useTrendResearchFilterParams';
import useKeyDesigns from '@features/trend-research/hooks/useTrendResearchKeyDesigns';
import EmptyState from '@features/trend-research/components/common/EmptyState';
import {
	Card,
	CardContent,
	FabricImageContainer,
	TopBar
} from '@features/trend-research/components/common/TrendCard';
import { filterFieldType } from '@features/filter/static/filterUtil';

import { useInsightSummary } from '@store/reducers/trend-research/TrendResearchReducer';
import { storeItemInGlobalFilter } from '@store/actions/FilterAction';
import { setTrendResearchSelectedGroup } from '@store/actions/trend-research/TrendResearchAction';

import { trackMixPanelEvent } from '@services/commonService';

import { processDecimalValue } from '@utils/Util';

const KeyFabrics = () => {
	const summaryCounts = useInsightSummary();
	const { requestBody } = useTrendResearchFilterParams();
	const dispatch = useDispatch();

	const { designs, isLoading } = useKeyDesigns('key-fabric', requestBody, 'noOfFabrics');

	const renderCards = () => {
		const handleRoute = (item) => {
			trackMixPanelEvent(
				{
					cardName: item.fabricName,
					groupType: 'FABRIC'
				},
				'TRENDS_GROUPED_CARD_ON_CLICK'
			);
			dispatch(
				storeItemInGlobalFilter({
					name: filterFieldType['TREND_COMPOSITION']['idName'],
					key: item.fabricName,
					value: item.fabricName,
					identifier: `${filterFieldType['TREND_COMPOSITION']['idName']}_${item.fabricName}`,
					checked: true
				})
			);
			dispatch(setTrendResearchSelectedGroup('DEFAULT'));
		};

		return designs?.map((item, idx) => {
			const [mainImage, ...images] = item?.imageUrlList || [];
			const contents = {
				title: item.fabricName.replaceAll('+', ' + '),
				itemCount: item.fabricCount,
				percentage: summaryCounts?.noOfProducts
					? processDecimalValue((item.fabricCount / summaryCounts.noOfProducts) * 100) + '%'
					: `0%`
			};
			return (
				<React.Fragment key={`fabric_${idx}`}>
					<Card className="single-fabric-item cursor-pointer" onClick={() => handleRoute(item)}>
						<TopBar topText={idx === 0} />
						<FabricImageContainer mainImage={mainImage} images={images} />
						<CardContent additionalClasses="" details={contents} tooltipSize={11} />
					</Card>
				</React.Fragment>
			);
		});
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div className="key-fabric-section trend-padding">
				<div className="section-title pb-3 d-flex align-items-center justify-content-between">
					<p className="semibold-16 gray_dark_01 d-flex align-items-center">
						<CommonImage src="/icons/flag/fabric.svg" alt="fabric" />
						<span className="pl-1"> Key Fabric</span>
					</p>
				</div>
				{designs.length > 0 ? (
					<div className="key-slider trending-slider">{renderCards()}</div>
				) : (
					<EmptyState />
				)}
			</div>
		</LoaderComponent>
	);
};

KeyFabrics.propTypes = {};

export default KeyFabrics;
